import getStringFromTypedArray from "./getStringFromTypedArray.js";

/**
 * @private
 */
function getMagic(uint8Array, byteOffset) {
  byteOffset = byteOffset ?? 0;
  let contentType = getStringFromTypedArray(
    uint8Array,
    byteOffset,
    Math.min(4, uint8Array.length),
  );
  if (contentType === "ply\n") {
    contentType = "ply";
  }
  return contentType;
}
export default getMagic;
